import 'bootstrap'

import './style.scss'

import Like from './Like'
import './formPosting'
import './ajax'
import './dropdown'
import './bottomMenu'
//import './comments'
import './commentsV2'
import './Rewards'
const like = new Like()

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ptdf-swiper').forEach(function (slider) {
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
            },
            // Optional for performance:
            lazy: true,
        })
    })


        let swiperInstance = null;
        const mq = window.matchMedia('(max-width: 767px)');

        function initSwiper(){
            if (swiperInstance) return;
            swiperInstance = new Swiper('#mobileSwiper', {
                slidesPerView: 3.9,       // 3 full + a peek
                spaceBetween: 3,         // tweak gap as needed
                resistanceRatio: 0.85,
                grabCursor: true,
                // Ensure taps on links still work; Swiper will block clicks only after a drag.
                preventClicks: true,
                preventClicksPropagation: true,
                // Optional: nicer momentum
                freeMode: false
            });

            // Extra safety: if a slide contains a link, only follow it when user didn't drag.
            // (Swiper sets allowClick=false after a drag gesture.)
            document.querySelectorAll('#mobileSwiper .swiper-slide a').forEach(a => {
                a.addEventListener('click', function(e){
                    if (!swiperInstance || swiperInstance.allowClick) return; // it's a tap
                    e.preventDefault(); // was a drag; don't open
                });
            });
        }

        function destroySwiper(){
            if (!swiperInstance) return;
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }

        function handleMQ(e){
            if (e.matches) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }

        // Run once and on change
        handleMQ(mq);
        mq.addEventListener ? mq.addEventListener('change', handleMQ) : mq.addListener(handleMQ);

})


